import React, { useEffect, useState } from 'react';
import { Replay as ReplayIcon } from '@mui/icons-material';
import FatigueAssessmentPage from "./FatigueAssessmentPage";
import FatigueAssessmentCardList from "./FatigueAssessmentCardList";
import { FatigueAssessmentView } from './FatigueAssessmentView';
import { myForm } from "./FatigueAssessmentPageSelector";


const FatigueAssessments = () => {
    return (
        <FatigueAssessmentPage selectedPage={myForm}>
            <div className="fa-list-container">
                <FatigueAssessmentCardList
                    view={[FatigueAssessmentView.MyForm]}
                    title={"Pending"}
                    titleIcon={<ReplayIcon />}
                />
            </div>
        </FatigueAssessmentPage>
    );
}

export default FatigueAssessments;
